const generatePassword = ({ length, includeNumbers, includeSymbols }) => {
  const pattern = new RegExp(`^[a-zA-Z${includeNumbers && "0-9"}${includeSymbols && "!@#$%^&*_+-"}]*$`);
  let char;
  let arr = new Uint8Array(1);

  return Array.apply(null, { length: length })
    .map(() => {
      while (true) {
        char = String.fromCharCode(window.crypto.getRandomValues(arr)[0]);
        if (pattern.test(char)) return char;
      }
    })
    .join("");
};

export default generatePassword;
